import React, {useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import AMCRegistrationView from "./AMCRegistrationView";

function AMCRegistration(props) {
    const [amcRegistrationState, setAMCRegistrationState] = useState({
        amcRegistrations: [
            {mutualFund: 'Tata Mutual Fund', amc: 'Tata Asset Management Pvt. Ltd.', regNo: 'MF/023/95/9', regDate: '30-Jun-1995'},
            {mutualFund: 'Franklin Templeton Mutual Fund', amc: 'Franklin Templeton AMC (India) Pvt. Ltd.', regNo: 'MF/026/96/8', regDate: '19-Feb-1996'},
            {mutualFund: 'Nippon India Mutual Fund', amc: 'Nippon Life India Asset Management Ltd.', regNo: 'MF/022/95/1', regDate: '30-Jun-1995'},
            {mutualFund: 'ICICI Prudential Mutual Fund', amc: 'ICICI Prudential AMC Ltd.', regNo: 'MF/003/93/6', regDate: '13-Oct-1993'},
            {mutualFund: 'Aditya Birla Sun Life Mutual Fund', amc: 'Aditya Birla Sun Life AMC Ltd.', regNo: 'MF/020/94/8', regDate: '23-Dec-1994'},
            {mutualFund: 'HDFC Mutual Fund', amc: 'HDFC Asset Management Co. Ltd.', regNo: 'MF/044/00/6', regDate: '30-Jun-2000'},
            {mutualFund: 'WhiteOak Capital Mutual Fund', amc: 'WhiteOak Capital Asset Management Ltd.', regNo: 'MF/074/18/02', regDate: '03-Jul-2018'},
            {mutualFund: 'Edelweiss Mutual Fund', amc: 'Edelweiss Asset Management Ltd.', regNo: 'MF/057/08/02', regDate: '30-Apr-2008'},
            {mutualFund: 'Motilal Oswal Mutual Fund', amc: 'Motilal Oswal AMC Ltd.', regNo: 'MF/063/09/04', regDate: '29-Dec-2009'},
            {mutualFund: 'DSP Mutual Fund', amc: 'DSP Investment Managers Pvt. Ltd.', regNo: 'MF/036/97/7', regDate: '30-Jan-1997'},
            {mutualFund: 'Axis Mutual Fund', amc: 'Axis Asset Management Co. Ltd.', regNo: 'MF/061/09/02', regDate: '04-Sep-2009'},
            {mutualFund: 'Bandhan Mutual Fund', amc: 'Bandhan AMC Ltd.', regNo: 'MF/042/00/3', regDate: '13-Mar-2000'},
            {mutualFund: 'Mirae Asset Mutual Fund', amc: 'Mirae Asset Investment Managers (India)', regNo: 'MF/055/07/03', regDate: '30-Nov-2007'},
            {mutualFund: 'Kotak Mahindra Mutual Fund', amc: 'Kotak Mahindra AMC Ltd.', regNo: 'MF/038/98/1', regDate: '23-Jun-1998'},
            {mutualFund: 'SBI Mutual Fund', amc: 'SBI Funds Management Ltd.', regNo: 'MF/009/93/3', regDate: '23-Dec-1993'},
            {mutualFund: 'HSBC Mutual Fund', amc: 'HSBC Asset Management (India) Pvt. Ltd.', regNo: 'MF/046/02/5', regDate: '27-May-2002'},
            {mutualFund: 'Invesco Mutual Fund', amc: 'Invesco Asset Management (India) Pvt. Ltd.', regNo: 'MF/052/06/01', regDate: '24-Jul-2006'},
            {mutualFund: 'Sundaram Mutual Fund', amc: 'Sundaram Asset Management Co. Ltd.', regNo: 'MF/034/97/2', regDate: '03-Jan-1997'},
            {mutualFund: 'UTI Mutual Fund', amc: 'UTI Asset Management Co. Ltd.', regNo: 'MF/048/03/01', regDate: '14-Jan-2003'},
            {mutualFund: 'PPFAS Mutual Fund', amc: 'PPFAS Asset Management Pvt. Ltd.', regNo: 'MF/069/12/01', regDate: '10-Oct-2012'},
            {mutualFund: 'JM Financial Mutual Fund', amc: 'JM Financial Asset Management Ltd.', regNo: 'MF/015/94/8', regDate: '15-Sep-1994'},
            {mutualFund: 'Canara Robeco Mutual Fund', amc: 'Canara Robeco Asset Management Co. Ltd.', regNo: 'MF/004/93/4', regDate: '19-Oct-1993'},
        ],
    });

    return (
        <AMCRegistrationView {...props} {...amcRegistrationState}/>
    );
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isMobileDevice: state.appState.deviceInfo.isMobileDevice,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isXSView: state.appState.deviceInfo.isXSView,
});

export default connect(mapStateToProps, {})(withRouter(AMCRegistration));
